export default __webpack_public_path__ + "static/media/logo.ed0befc9.png";